var map = {
	"./with-neck/female.svg": "44ce",
	"./with-neck/male.svg": "41a7",
	"./with-neck/other.svg": "05387",
	"./without-neck/female.svg": "afb1",
	"./without-neck/male.svg": "79e8",
	"./without-neck/other.svg": "07de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80e4";